import styles from './index.module.scss'

export function MySpaceLayout({ children }) {
  return (
    <div className={styles.dashboard}>
      <div className={styles.content}>{children}</div>
    </div>
  )
}
